import React from 'react';
import { Link } from 'react-router-dom';
import Text from '../ui/text';

function breadcrumbsFor(categories) {
  return [...categories]
    .reverse()
    .map(({ name, url }) => ({ name, url: '/' + url }));
}

function Breadcrumbs(props) {
  const product = props.product || {};
  const parentCategories = props.parentCategories || [];
  const breadcrumbs = breadcrumbsFor(parentCategories);

  return (
    <Text title secondary size="xs" weight="med">
      <a href="/">Saucey</a>

      {breadcrumbs.length ? (
        breadcrumbs.map(category => (
          <span key={category.url}>
            <span> / </span>
            <Link to={category.url}>{category.name}</Link>
          </span>
        ))
      ) : product.categoryUrl && product.category ? (
        <span>
          <span> / </span>
          <Link to={product.categoryUrl}>{product.category.name}</Link>
        </span>
      ) : null}
    </Text>
  );
}

export default Breadcrumbs;
export { breadcrumbsFor };



// WEBPACK FOOTER //
// ./shared/components/product/breadcrumbs.js